/* eslint-disable */
import React, { useCallback, useRef } from 'react';
import './index.less';

export interface IWhyStudentTargetReasonItem {
  desc?: string;
  title?: string;
}

export interface IWhyStudentTargetReasonsProps {
  title?: string;
  description?: string;
  items?: IWhyStudentTargetReasonItem[];
  id?: string;
  className?: string;
  onComplete?: () => void;
}

const WhyStudentTargetReasons = React.forwardRef<
  HTMLDivElement,
  IWhyStudentTargetReasonsProps
>(({ title, description, items = [], id, className, onComplete }, ref) => {
  const completedRef = useRef(false);

  const markComplete = useCallback(() => {
    if (completedRef.current) return;
    completedRef.current = true;
    onComplete?.();
  }, [onComplete]);

  if (!items.length && !title && !description) return null;

  return (
    <div
      ref={ref}
      className={`why-student-training-target-reasons-block${
        className ? ` ${className}` : ''
      }`}
      id={id}
    >
      {title ? (
        <h2 className="why-student-training-target-reasons-title">{title}</h2>
      ) : null}
      {description ? (
        <p className="why-student-training-target-reasons-desc">
          {description}
        </p>
      ) : null}
      <div
        className="why-student-training-target-reasons"
        onMouseEnter={markComplete}
      >
        {items.map((item, index) => (
          <div key={index} className="why-student-training-target-reason">
            {item.title ? (
              <div className="why-student-training-target-reason-num reason-title">
                {item.title}
              </div>
            ) : (
              <div className="why-student-training-target-reason-num">
                {String(index + 1).padStart(2, '0')}
              </div>
            )}
            <p className="why-student-training-target-reason-text">
              {item.desc}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
});

WhyStudentTargetReasons.displayName = 'WhyStudentTargetReasons';

export default React.memo(WhyStudentTargetReasons);
